import queryStringBuilder, { QueryParams } from './../../../utils/queryStringBuilder'
import { NavigateFunction } from 'react-router-dom'
import showResponseError from '../../../utils/showResponseError'
import { t } from 'i18next'
/* eslint-disable camelcase */
import {
  createSlice,
  PayloadAction,
  createAsyncThunk,
  ActionReducerMapBuilder,
} from '@reduxjs/toolkit'

import { AppHttpConfig as API } from '../../../services/httpConfig'
import {
  IProclamationInitialState,
  PricingList,
  PricingResponse,
  Proclamation,
  ProclamationList,
  ProclamationResponse,
} from './types'
import { PricingUrl, ProclamationUrl } from './urls'
import toastify from '../../../utils/toastify'
import { ToastType } from '../../../types/generalType'
import hasObjectData from '../../../utils/hasObjectData'

const initialState: IProclamationInitialState = {
  loading: false,
  proclomation: {
    proclomationList: {
      currentPage: 1,
      loading: false,
      dataList: {
        total: 0,
        data: [],
      },
    },
    proclomationItem: {
      loading: false,
      itemData: null,
    },
    createProclomation: {
      loading: false,
    },
    updateProclomation: {
      loading: false,
    },
  },
  pricing: {
    pricingList: {
      currentPage: 1,
      loading: false,
      dataList: {
        total: 0,
        data: [],
      },
    },
    pricingItem: {
      loading: false,
      itemData: null,
    },
    createPricing: {
      loading: false,
    },
    updatePricing: {
      loading: false,
    },
  },
}

// get all proclamation
export const getAllProclamations = createAsyncThunk<
  ProclamationResponse,
  QueryParams,
  { rejectValue: { errorMessage: string } }
>('proclamation/getAllProclamations', async (data, thunkAPI) => {
  const query = hasObjectData(data) ? queryStringBuilder(data) : ''

  try {
    const response = await API.get(`${ProclamationUrl.GetAll}${query}`)
      .then((res) => {
        if (res.status === 200) {
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
        return thunkAPI.rejectWithValue(error[0])
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})
// get proclamation by id
export const getProclamationById = createAsyncThunk<ProclamationList, string>(
  'proclamation/getProclamationById',
  async (id: string) => {
    try {
      const response = await API.get(`${ProclamationUrl.GetById}?id=${id}`)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)
// crate proclamation
export const createProclamation = createAsyncThunk<
  number,
  { data: Proclamation; navigate: NavigateFunction }
>('proclamation/createProclamation', async (command) => {
  const { data, navigate } = command
  try {
    const response = await API.post(ProclamationUrl.CreateProclamation, data)
      .then((res) => {
        if (res.status === 201) {
          navigate('/Proclamation')
          toastify(ToastType.SUCCESS, { operatin: t('save'), pageName: t('period') })
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})
// update proclamation
export const updateProclamation = createAsyncThunk<
  any,
  { data: ProclamationList; navigate: NavigateFunction }
>('proclamation/updateProclamation', async (command) => {
  const { data, navigate } = command

  try {
    const response = await API.put(ProclamationUrl.UpdateProclamation, data)
      .then((res) => {
        if (res.status === 201) {
          toastify(ToastType.SUCCESS, { operatin: t('edit'), pageName: t('period') })
          navigate('/Proclamation')
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})

// Pricing
// get all group pricing
export const getAllGroupPricing = createAsyncThunk<PricingResponse>(
  'proclamation/pricing/getAllGroupPricing',
  async () => {
    try {
      const response = await API.get(PricingUrl.GetAll)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)
// get all group pricing by Id
export const getGroupPricingById = createAsyncThunk<PricingList, string>(
  'proclamation/pricing/getGroupPricingById',
  async (id: string) => {
    try {
      const response = await API.get(`${PricingUrl.GetPricingById}?id=${id}`)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)
// get all group pricing by proclamation Id
export const getGroupPricingByProclamationId = createAsyncThunk<PricingResponse, string>(
  'proclamation/pricing/getGroupPricingByProclamationId',
  async (proclamationId: string) => {
    try {
      const response = await API.get(
        `${PricingUrl.GetByProclamationId}?ProclamationId=${proclamationId}`,
      )
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)
// crate pricing
export const createPricing = createAsyncThunk<
  number,
  { data: PricingList; navigate: NavigateFunction }
>('proclamation/pricing/createPricing', async (command) => {
  const { data, navigate } = command
  try {
    const response = await API.post(PricingUrl.CreatePricing, data)
      .then((res) => {
        if (res.status === 201) {
          navigate(`/Proclamation/${data.proclamation}/Pricing`)
          toastify(ToastType.SUCCESS, { operatin: t('save'), pageName: t('pricing') })
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})
// update pricing
export const updatePricing = createAsyncThunk<
  number,
  { data: PricingList; proclamationId: string | undefined; navigate: NavigateFunction }
>('proclamation/pricing/updatePricing', async (command) => {
  const { data, proclamationId, navigate } = command

  try {
    const response = await API.put(PricingUrl.UpdatePricing, data)
      .then((res) => {
        if (res.status === 201) {
          toastify(ToastType.SUCCESS, { operatin: t('edit'), pageName: t('pricing') })
          navigate(`/Proclamation/${proclamationId}/Pricing`)
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})

const proclamationSlice = createSlice({
  name: 'proclamation',
  initialState,
  reducers: {
    clearProclamationList: (state) => {
      state.proclomation.proclomationList.dataList = { total: 0, data: [] }
      state.proclomation.proclomationList.currentPage = 1
    },
    clearPricingList: (state) => {
      state.pricing.pricingList.dataList = { total: 0, data: [] }
      state.pricing.pricingList.currentPage = 1
    },
    clearPricingItemData: (state) => {
      state.pricing.pricingItem.itemData = null
    },
    setProclamationCurrentPage: (state, action: PayloadAction<number>) => {
      state.proclomation.proclomationList.currentPage = action.payload
    },
    setPricingCurrentPage: (state, action: PayloadAction<number>) => {
      state.pricing.pricingList.currentPage = action.payload
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IProclamationInitialState>) => {
    // get all proclamation list
    builder
      .addCase(getAllProclamations.pending, (state) => {
        state.proclomation.proclomationList.loading = true
      })
      .addCase(
        getAllProclamations.fulfilled,
        (state, action: PayloadAction<ProclamationResponse, any>) => {
          state.proclomation.proclomationList.loading = false
          state.proclomation.proclomationList.dataList = action.payload
        },
      )
      .addCase(getAllProclamations.rejected, (state) => {
        state.proclomation.proclomationList.loading = false
        state.proclomation.proclomationList.dataList = {
          total: 0,
          data: [],
        }
      })

    // get proclamation by id
    builder
      .addCase(getProclamationById.pending, (state) => {
        state.proclomation.proclomationList.loading = true
      })
      .addCase(
        getProclamationById.fulfilled,
        (state, action: PayloadAction<ProclamationList, any>) => {
          state.proclomation.proclomationList.loading = false
          state.proclomation.proclomationItem.itemData = action.payload
        },
      )
      .addCase(getProclamationById.rejected, (state) => {
        state.proclomation.proclomationList.loading = false
        state.proclomation.proclomationItem.itemData = null
      })

    // create proclamation
    builder
      .addCase(createProclamation.pending, (state) => {
        state.proclomation.createProclomation.loading = true
      })
      .addCase(createProclamation.fulfilled, (state) => {
        state.proclomation.createProclomation.loading = false
      })
      .addCase(createProclamation.rejected, (state) => {
        state.proclomation.createProclomation.loading = false
      })
    // update proclamation
    builder
      .addCase(updateProclamation.pending, (state) => {
        state.proclomation.updateProclomation.loading = true
        state.proclomation.proclomationItem.itemData = null
      })
      .addCase(updateProclamation.fulfilled, (state) => {
        state.proclomation.updateProclomation.loading = false
      })
      .addCase(updateProclamation.rejected, (state) => {
        state.proclomation.updateProclomation.loading = false
        state.proclomation.proclomationItem.itemData = null
      })

    // Pricing
    // get all group pricing
    builder
      .addCase(getAllGroupPricing.pending, (state) => {
        state.pricing.pricingList.loading = true
      })
      .addCase(
        getAllGroupPricing.fulfilled,
        (state, action: PayloadAction<PricingResponse, any>) => {
          state.pricing.pricingList.loading = false
          state.pricing.pricingList.dataList = action.payload
        },
      )
      .addCase(getAllGroupPricing.rejected, (state) => {
        state.pricing.pricingList.loading = false
        state.pricing.pricingList.dataList.data = []
      })
    // get group pricing by id
    builder
      .addCase(getGroupPricingById.pending, (state) => {
        state.pricing.pricingItem.loading = true
      })
      .addCase(getGroupPricingById.fulfilled, (state, action: PayloadAction<PricingList, any>) => {
        state.pricing.pricingItem.loading = false
        state.pricing.pricingItem.itemData = action.payload
      })
      .addCase(getGroupPricingById.rejected, (state) => {
        state.pricing.pricingItem.loading = false
        state.pricing.pricingItem.itemData = null
      })
    // get group pricing by proclamation id
    builder
      .addCase(getGroupPricingByProclamationId.pending, (state) => {
        state.pricing.pricingList.loading = true
      })
      .addCase(
        getGroupPricingByProclamationId.fulfilled,
        (state, action: PayloadAction<PricingResponse, any>) => {
          state.pricing.pricingList.loading = false
          state.pricing.pricingList.dataList = action.payload
        },
      )
      .addCase(getGroupPricingByProclamationId.rejected, (state) => {
        state.pricing.pricingList.loading = false
        state.pricing.pricingList.dataList = {
          total: 0,
          data: [],
        }
      })
    // create pricing
    builder
      .addCase(createPricing.pending, (state) => {
        state.pricing.createPricing.loading = true
      })
      .addCase(createPricing.fulfilled, (state) => {
        state.pricing.createPricing.loading = false
      })
      .addCase(createPricing.rejected, (state) => {
        state.pricing.createPricing.loading = false
      })
    // update pricing
    builder
      .addCase(updatePricing.pending, (state) => {
        state.pricing.updatePricing.loading = true
        state.pricing.pricingItem.itemData = null
      })
      .addCase(updatePricing.fulfilled, (state) => {
        state.pricing.updatePricing.loading = false
      })
      .addCase(updatePricing.rejected, (state) => {
        state.pricing.updatePricing.loading = false
        state.pricing.pricingItem.itemData = null
      })
  },
})

export const {
  clearProclamationList,
  clearPricingList,
  clearPricingItemData,
  setProclamationCurrentPage,
  setPricingCurrentPage,
} = proclamationSlice.actions

export default proclamationSlice.reducer
